import { render, staticRenderFns } from "./BackTestForm.vue?vue&type=template&id=39ca5238&scoped=true&"
import script from "./BackTestForm.vue?vue&type=script&lang=js&"
export * from "./BackTestForm.vue?vue&type=script&lang=js&"
import style0 from "./BackTestForm.vue?vue&type=style&index=0&id=39ca5238&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ca5238",
  null
  
)

export default component.exports